<h1 mat-dialog-title class="drilldown-title">User Picker</h1>

<div style="margin-bottom: 5px;">
  <button mat-raised-button class="applyFilterButton" (click)="applyChanges()" [mat-dialog-close]="true">Apply Filter</button>
  <button mat-raised-button class="applyFilterButton" (click)="clearSelectedEveUsers()">Clear Selection</button>

  <input class="searchFilterInput" type="text" placeholder="Search" [formControl]="searchControl">
</div>
  
<div mat-dialog-content>
  <!--<graphql-data-table [query]="data.query">

  </graphql-data-table>-->



  <ng-container *ngIf="eveUsersPageObservable | async as eveUsersPage; else loading;">
    
    

    <div style="display: inline-block; vertical-align: top;">
      <span class="material-icons evePaginatorArrow" matTooltip="Previous Page" [class.disabled]="!userPaginator.hasPreviousPage()" [class.enabled]="userPaginator.hasPreviousPage()" (click)="userPaginator.previousPage()">arrow_back_ios</span>      
    </div>

    <div style="display: inline-block; vertical-align: top;">
      <mat-grid-list cols="12" rowHeight="50px" [gutterSize]="'0px'" class="userGridListStyling">
        <mat-grid-tile *ngFor="let eveUser of eveUsersPage.items" (click)="onSelectEveUser(eveUser);"
                       [colspan]="3"
                       [rowspan]="4"
                       style="cursor: pointer;">
          <span *ngIf="eveUser.selected" class="avatarSelectedOverlay material-icons">done</span>
          <img matTooltip="{{eveUser.firstName}} {{eveUser.surname}}" matTooltipPosition="above" src="{{reportingUrl}}/Library/GetUserAvatar?libraryId={{eveUser.avatarImageId ?? -1}}" style="border-radius: 50%;" />
          <mat-grid-tile-footer class="userFooterStyling">
            <div class="username">
              {{eveUser.firstName}} {{eveUser.surname}}
            </div>
          </mat-grid-tile-footer>
        </mat-grid-tile>
      </mat-grid-list>
      <div *ngIf="eveUsersPage.items.length == 0">
        <img src="{{reportingUrl}}/Images/eveLogo.png" alt="eve Logo" style="opacity: 0.2; color: gray; display: block; margin: 70px auto 0 auto;" />
        <div style="color: #646965; text-align: center">no users found</div>
      </div>
    </div>

    <div style="display: inline-block;">
      <span class="material-icons evePaginatorArrow" matTooltip="Next Page" [class.disabled]="!userPaginator.hasNextPage()" [class.enabled]="userPaginator.hasNextPage()" (click)="userPaginator.nextPage()">arrow_forward_ios</span>
    </div>   
    
  </ng-container> 

  <mat-paginator style="display:none;" #userPaginator [length]="totalCount" [pageSize]="8" [pageSizeOptions]="[8,16,24]"></mat-paginator>

</div>


<ng-template #loading>
  <span class="fa fa-spinner fa-pulse fa-5x" style="opacity: 1; color:gray;"></span>
</ng-template>
